import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import CustomImageUpload from "../../../component/CustomImageUpload";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const addCategoryEndPoints = ApiEndpoints.productCategory.categoryCreate;

export default function NewsCreate() {
  const navigate = useNavigate();

  const [previews, setPreviews] = useState({category_thumbnail: null, logos: [null]});

  const [postData, setPostData] = useState({name: "", slug: "", brief: "", button_text: "",  category_thumbnail: null,  alt_category_thumbnail: "",  logos: [{ image: null, alt_image: "" }, { image: null, alt_image: "" }]});


  const handleImageChange = (index, file) => {
    const updatedImages = [...postData.logos];
    updatedImages[index].image = file;

    setPostData(prev => ({
      ...prev,
      logos: updatedImages
    }));

    const updatedPreviews = [...previews.logos];
    updatedPreviews[index] = URL.createObjectURL(file);

    setPreviews(prev => ({
      ...prev,
      logos: updatedPreviews
    }));
  };

  const handleAltChange = (index, value) => {
    const updatedImages = [...postData.logos];
    updatedImages[index].alt_image = value;

    setPostData(prev => ({
      ...prev,
      logos: updatedImages
    }));
  };


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const isEmptyValue = (value) => {
    if (value === null || value === "") return true;

    // allow File objects
    if (value instanceof File) return false;

    // arrays
    if (Array.isArray(value)) {
      return value.some(item => isEmptyValue(item));
    }

    // objects
    if (typeof value === "object") {
      return Object.values(value).some(v => isEmptyValue(v));
    }

    return false;
  };
  

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault(); 

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }

      if (isEmptyValue(value)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const logosPayload = postData.logos.map((item) => ({
      image: item.image ? item.image.name : "",
      alt_image: item.alt_image
    }));

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (key !== "images") {
        formData.append(key, value);
      }
      if (key === "logos") {
        formData.append(key, JSON.stringify(logosPayload))
      }
    });

    postData.logos.forEach((item, index) => {
      if (item.image) {
        formData.append(`logos[${index}][image]`, item.image);
      }
    });

    try {
      const response = await ApiRequest("POST", addCategoryEndPoints, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/product-category");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };


  // =================Add More Functionality Start=====================

  const addImageBlock = () => {
    setPostData(prev => ({
      ...prev,
      logos: [...prev.logos, { image: null, alt_image: "" }]
    }));

    setPreviews(prev => ({
      ...prev,
      logos: [...prev.logos, null]
    }));
  };

  const removeImageBlock = (index) => {
    if (index === 0) return; // first one protected

    setPostData(prev => ({
      ...prev,
      logos: prev.logos.filter((_, i) => i !== index)
    }));

    setPreviews(prev => ({
      ...prev,
      logos: prev.logos.filter((_, i) => i !== index)
    }));
  };
  

    const pagename = {
      name: 'Product Management',
      user: 'Admin',
      innerpage: 'Product Management / Category  / Add Category'
    }

  return (
    <>
      <AdminHeader pagename={pagename}/>
      
      <div className="add-content-page">
        <form id="newsAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Name<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="name" type="text" className="form-control" placeholder="Enter Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Brief<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="brief" type="text" className="form-control" placeholder="Enter Brief" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Button Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="button_text" type="text" className="form-control" placeholder="Enter Button Text" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image (360 × 302)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="category_thumbnail"
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    requiredWidth={360}
                    requiredHeight={302}
                    imagePreview={previews.category_thumbnail}/>
                </div>
              </div>  

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image Alt Tag<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_category_thumbnail" type="text" className="form-control" placeholder="Alt Tag" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              {postData.logos.map((item, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="add-page-inputs">

                    <div className="label-wrap-add">
                      <label>Logo {index + 1} (93 × 60)<small>*</small></label>
                    </div>

                    <CustomImageUpload name={`logos_${index}`} acceptedFormats={[".webp"]} imagePreview={previews.logos[index]} onImageChange={(e) => handleImageChange(index, e.target.files[0])} requiredWidth={93} requiredHeight={60}/>

                    <div className="label-wrap-add">
                      <label>Alt Tag Logo {index + 1}<small>*</small></label>
                    </div>

                    <input type="text" className="form-control mt-2" placeholder="Alt Tag" value={item.alt_image} onChange={(e) => handleAltChange(index, e.target.value)} />

                    {index > 1 && (
                      <button type="button" className="btn btn-sm btn-danger mt-2" onClick={() => removeImageBlock(index)}>
                        Remove
                      </button>
                    )}

                  </div>
                </div>
              ))}

              <div className="col-lg-12 add-page-inputs">
                <button type="button" className="addmore-images w-100" onClick={addImageBlock}>
                  Add Logo +
                </button>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="newsAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
